<template>
  <v-dialog v-model="dialog" persistent width="1300">
    <v-card>
      <v-card-title class="headline">
        <v-flex xs9> <v-icon>refresh</v-icon>Movilidad</v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="py-0 px-1">
        <v-container grid-list-md style="min-width:100%" class="py-0">
          <v-layout wrap row>
            <v-flex xs12>
              <v-select
                class="text-field-reducido-border"
                v-model="form.id_tipo_justificacion"
                :items="tipo_movimientos"
                item-text="descripcion"
                :item-value="val => parseInt(val.id)"
                label="Tipo de movimiento"
                :rules="$validate(['required'])"
                required
                :disabled="!!movilidad.id"
                outline
              ></v-select>
            </v-flex>
            <v-flex xs12>
              <RetiroPasante
                v-if="form.id_tipo_justificacion == 4"
                :movilidad="movilidad"
                :id_tipo_justificacion="form.id_tipo_justificacion"
              />
              <IncorporacionPasante
                v-if="form.id_tipo_justificacion == 3"
                :movilidad="movilidad"
                :id_tipo_justificacion="form.id_tipo_justificacion"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones
import IncorporacionPasante from "../components/IncorporacionPasante.vue";
import RetiroPasante from "../components/RetiroPasante.vue";
export default {
  components: {
    RetiroPasante,
    IncorporacionPasante
  },
  mixins: [validate],
  data() {
    return {
      dialog: false,
      form: {},
      tipo_movimientos: [],
      movilidad: {},
      unidades: [],
      cargos: [],
      puestos: []
    };
  },
  async mounted() {
    await this.obtenerTipoJustificaciones();
    this.$bus.$on("openDialogNuevaMovilidadPasante", item => {
      this.movilidad = item;
      this.form = {
        id_tipo_justificacion: this.movilidad.id
          ? this.movilidad.id_tipo_justificacion
          : null
      };
      this.dialog = true;
    });
    this.$bus.$on("closeDialogNuevaMovilidadPasante", item => {
      this.close();
    });
  },
  methods: {
    async obtenerTipoJustificaciones() {
      try {
        let res = await this.$service.graphql({
          query: `
            query{
              tipoJustificacions(tipo: "activo"){
                rows{
                  id
                  descripcion
                  id_estado
                }
              }
            }
          `
        });
        this.tipo_movimientos = res.tipoJustificacions.rows;
      } catch (error) {
        console.log(error);
      }
    },

    close() {
      this.form = {};
      this.movilidad = {};
      this.$bus.$emit("closeDialogMovilidad");
      this.dialog = false;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/movilidad/dialogs/NuevaMovilidadPasante.vue